import React from "react";
import axios from "axios";

const DocumentCard = ({ doc, onStatusChange }) => {

  const handleAction = async (status) => {
    try {
      const res = await axios.post("https://gantasoft.in/cab-g/dev/driver/v1//update_document_status.php", {
        id: doc.id,
        status: status
      });

      if (res.data.success) {
        onStatusChange(); // refresh list
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-xl p-4 w-full md:w-80">
      
      {/* Document Title */}
      <h2 className="text-lg font-semibold mb-2">{doc.title}</h2>

      {/* Image */}
      {doc.file_url ? (
        <img
          src={`${doc.file_url}`}
          alt={doc.title}
          className="w-full h-40 object-cover rounded-lg border"
        />
      ) : (
        <div className="w-full h-40 flex items-center justify-center bg-gray-100 rounded-lg">
          <span className="text-gray-400">No Document</span>
        </div>
      )}

      {/* Status */}
      <div className="mt-3">
        <span
          className={`px-3 py-1 text-sm rounded-full 
            ${doc.status === "verified" ? "bg-green-100 text-green-600" : ""}
            ${doc.status === "pending" ? "bg-yellow-100 text-yellow-600" : ""}
            ${doc.status === "rejected" ? "bg-red-100 text-red-600" : ""}
            ${doc.status === "expired" ? "bg-gray-200 text-gray-600" : ""}
          `}
        >
          {doc.status}
        </span>
      </div>

      {/* Buttons */}
      <div className="flex gap-2 mt-4">
        
        <button
          onClick={() => handleAction("verified")}
          className="flex-1 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
        >
          Approve
        </button>

        <button
          onClick={() => handleAction("rejected")}
          className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
        >
          Reject
        </button>

      </div>

    </div>
  );
};

export default DocumentCard;